import { render, staticRenderFns } from "./PaymentModalComponent.vue?vue&type=template&id=7386223c&scoped=true&"
import script from "./PaymentModalComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7386223c",
  null
  
)

export default component.exports